import React, {Component, PropTypes} from 'react';
import Input from '../components/Forms/Input.jsx';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import AuthActions from '../reflux/AuthActions';
import AlertsStore from '../reflux/stores/AlertsStore';
import AuthStore from '../reflux/stores/AuthStore';
import CircularProgress from 'material-ui/CircularProgress';

class Register extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            alertTitle: '',
            alertOpen: false,
            alertMessages: null,
            loading: false
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleAlerts = this.handleAlerts.bind(this);
        this.handleAuth = this.handleAuth.bind(this);
    }

    componentDidMount() {
        this.unsubscribeAlerts = AlertsStore.listen(this.handleAlerts);
        this.unsubscribeAuth = AuthStore.listen(this.handleAuth);
    }

    componentWillUnmount() {
        this.unsubscribeAlerts();
        this.unsubscribeAuth();
    }

    handleAuth(e) {
        this.setState({loading: false});
        switch(e) {
            case 'login_success':
                this.props.router.push('/');
                break;
            case 'auth_success':
                this.props.router.push('/');
                break;

        }
    }

    onChange(e, value) {
        this.setState({email: value});
    }

    onSubmit(e) {
        e.preventDefault();
        this.setState({loading:true});
        AuthActions.forgot(this.state.email);
    }

    /**
     * Handles all incoming alerts and displays a modal with the messages
     * 
     * @param {string} e The type of alert that is being sent.
     * @param {string} title The title for the modal
     * @param {any} messages the messages to be displayed as children of modal
     * 
     * @return {void}
     */
    handleAlerts(e, title, messages) {
        switch(e) {
            case 'open':
                this.setState({
                    alertTitle: title,
                    alertOpen:true, 
                    alertMessages: messages
                });
                break;
            case 'close':
                this.setState({
                    alertTitle: 'title',
                    alertOpen:false, 
                    alertMessages: null
                });
                break;
            case 'stopLoading':
                this.setState({
                    loading: false
                });
                break;
        }
    }

    render() {
        const containerStyle = {
            width:'100%',
            margin:'auto',
            marginTop: 50
        };

        const registroStyle = {
            width: '100%',
            marginTop:10,
            marginRight:0,
        };

        const style = {
            marginTop:10,
            marginRight:0,
            width:'100%'
        };

        const loginStyle = {
            marginTop:10,
            marginRight:0,
            width:'100%'
        };

        return (
            <div style={{width:'100%', height: '100%', position:'absolute', background:this.context.muiTheme.palette.primary1Color, marginTop:-60}}>
            <div style={containerStyle} >
                <Paper style={{padding:'10px 20px 20px 20px', maxWidth:400, width:'100%', position:'relative', margin:'auto'}}>
                <h1 style={{textAlign:'center'}}>Recuperar Contraseña</h1>
                <form action="/#/register" method="POST" onSubmit={this.onSubmit}>
                    <Input
                    validations="required,email" 
                    floatingLabelText="Dirección de Email"
                    fullWidth={true}
                    name="email"
                    val={this.state.email}
                    onChange={this.onChange}
                    debounce={0} />
                    
                    <RaisedButton type="submit" label="Recuperar" secondary={true} style={loginStyle} />
                </form>

                <div style={{position:'absolute', top:0, left:0, width:'100%', height:'100%', background:'rgba(197, 197, 197, 0.3)', display: this.state.loading ? 'block' : 'none', zIndex:100}}>
                    <div style={{position:'relative', textAlign:'center'}}>
                        <div style={{position:'relative'}}>
                        <CircularProgress size={2} />
                        </div>
                    </div>
                    
                </div>
                
                <Dialog
                    title={this.state.alertTitle}
                    modal={true}
                    actions={<FlatButton label="Cerrar" onTouchTap={this.handleAlerts.bind(this, 'close')}/>}
                    open={this.state.alertOpen}>
                    {this.state.alertMessages}
                </Dialog> 
                </Paper> 
            </div>
            </div>
        );
    }
}

Register.contextTypes = {
    muiTheme: PropTypes.object.isRequired,
};

export default Register;


/** WEBPACK FOOTER **
 ** ./app-react/pages/ForgotPwdPage.jsx
 **/